import React, { Component, Fragment } from 'react';
import Logo from '../../../assets/images/logo4.png';
import productPic from '../../../assets/images/default-profile.jpg';
import LogoSmall from '../../../assets/images/Group.png';

import { UtilityService } from "../../../services";
//
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToggleChange } from '../../../redux/action/Header';
import { signOut } from '../../../redux/action/main';
import options from '../../../services/common/options';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            toggle: true
        };
        this.logOut = this.logOut.bind(this)
        this.toggleChange = this.toggleChange.bind(this)
    }
    
    componentDidMount() {
      
    }
    toggleChange() {
        function hasClass(element, className) {
            return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
        }
        var toggleClass = document.getElementById("toggle-nav-bar")
        let toggle = hasClass(toggleClass, "class-nav-bar")
        this.setState({ toggle })
        this.props.ToggleChange(toggle)
    }
    
    logOut() {
        localStorage.removeItem("authToken");
        localStorage.clear();
        this.props.signOut();
        this.props.history !== undefined && this.props.history.push("/")
    }

    render() {

        var { toggle } = this.state
        const { userDetails } = this.props;
        return (
            <Fragment>
                <div className="top-bar">
                    <div className="logo">
                        <a onClick={() => this.props.history.push("/")}><img src={!this.props.toggle ? LogoSmall : Logo} alt="Magnum" /></a>
                    </div>
                    <div className="top-menu">
                        <ul>
                            <li className="pro-img"><img className="pro-img-src" src={(userDetails.profilePicture) !== "" ? (UtilityService.fileUrl() + userDetails.profilePicture) : (productPic)} alt="" /></li>
                            <li className="user-logged">HI! {`${userDetails.firstName} ${userDetails.lastName}`}</li>
                            <li><a onClick={() => this.props.history.push("/profile")} style={{ cursor: "pointer", color: "white" }} >PROFILE</a></li>
                            <li onClick={() => this.logOut()}><a style={{ cursor: "pointer", color: "white" }}>LOGOUT</a></li>
                        </ul>
                    </div>
                </div>

            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        toggle: state.Header.toggle,
        userDetails : state.main
    });
}

const mapDispatchToProps = (dispatch) => {

        // options.filter((data) => data.moduleName == this.props.location.moduleName)

    return bindActionCreators({
        "ToggleChange": ToggleChange,
        "signOut" : signOut
    }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));







// WEBPACK FOOTER //
// ./src/components/mainLayout/header/component.js